import React from "react";
import { Box, Container } from '@mui/system';
import Grid from '@mui/material/Grid';

import { RightElement } from '../components/common/RightElement'
import { ForgotPasswordHeader } from "../components/forms/ForgotPassword/ForgotPasswordHeader";
import { useForgotPassword } from "../hooks/useForgotPassword";
import { ForgotPasswordForm } from "../components/forms/ForgotPassword/ForgotPasswordForm";
const ForgotPasswordPage = ()=>{
    const imgSrc = "./cat-7.png"

    const {errors, formData, handleSubmit, onChange, isLoading, serverError, sentOtp, handleClickPasswordShowOff, showPassword, enterOtp} = useForgotPassword()
    
    return(
        <>
        <Container maxWidth="lg" className="parentdiv register-form mb-40">
            {/* <Box><ForgotPasswordHeader/></Box> */}
        <Box>
            <Grid container>
                <Grid item xs={12} md={6} className="login">
                    <ForgotPasswordForm
                    handleSubmit={handleSubmit}
                    formData={formData}
                    errors={errors}
                    onChange={onChange}
                    sentOtp={sentOtp}
                    isLoading={isLoading}
                    serverError={serverError}
                    showPassword={showPassword}
                    handleClickPasswordShowOff={handleClickPasswordShowOff}
                    enterOtp={enterOtp}

                    />
                </Grid>
                <Grid item xs={12} md={6} >
                    <RightElement imgSrc={imgSrc}/>
                </Grid>                
            </Grid>
        </Box>
        </Container>
        </>
    )
}

export {ForgotPasswordPage}

